
import * as Sentry from "@sentry/browser"
import { SeverityLevel } from "@sentry/types"
import log from "plugins/loglevel"

interface CaptureExceptionOptions {
  tags?: { [key: string]: string },
}

const captureException = (
  exception: Error,
  context: {
    [key: string]: string | number | boolean | {
      [key: string]: string | number | boolean
    }
  } = {},
  options: CaptureExceptionOptions = {}) => {
  const tags: { [key: string]: string } = (options.tags || {})

  log.error("exception: ")
  log.error(exception)
  log.error("context: ")
  log.error(context)

  Sentry.withScope((scope) => {
    scope.setExtras(context)
    scope.setTags(tags)
    Sentry.captureException(exception)
  })
}

interface CaptureMessageOptions {
  tags?:  { [key: string]: string },
  level?: SeverityLevel,
}

const captureMessage = (
  message: string,
  context: {
    [key: string]: undefined | null | string | number | boolean | {
      [key: string]: undefined | null | string | number | boolean
    }
  } = {},
  options: CaptureMessageOptions = {}) => {
  const tags: { [key: string]: string } = (options.tags || {})

  log.error("message: ")
  log.error(message)
  log.error("context: ")
  log.error(context)

  let level: SeverityLevel = "error"
  if (typeof options.level === "string") {
    level = options.level
  }

  Sentry.withScope((scope) => {
    scope.setExtras(context)
    scope.setTags(tags)
    scope.setLevel(level)
    Sentry.captureMessage(message)
  })
}

export {
  captureException,
  captureMessage,
}
